import dateFormat from 'dateformat';
import { getNumberFormat } from '../../../utils/number-utils';
import Form from '../../../form_builder_2/form';
import { scrollToElement } from '../../../utils/dom';
import Tooltip from '../../../utils/tooltip';
import AnalyticsHelper from '../../../utils/analytics-helper';
import { pushEmailAnalytics } from '../../../utils/ecomm-email-analytics';
import KEYS from '../../../utils/keyboard-keys-helper';

export default class PartExchangeSearch {
    constructor(parent) {
        this.parent = parent;
        this.myAccount2 = window.HONDA.MyAccount2;
        this.client = parent.client;
        this.partEx = parent.partEx;
        this.el = parent.el;
        this.formatPrice = parent.formatPrice;
        this.data = parent.parent.data;

        this.displayState = {
            visible: [],
            hidden: [],
        };

        this.setSelectors();
        this.getInitialDisplayState();
        this.setTemplates();
        this.initForms();
        this.bind();
    }

    setSelectors() {
        // warnings
        this.noMoreValuationsSearch = this.el.querySelector('#part-ex-nomore-valuations-warning');
        this.carSearchFailed = this.el.querySelector('#part-ex-car-search-failed');
        this.carValuationFailed = this.el.querySelector('#part-ex-car-valuation-failed');

        this.searchBlock = this.el.querySelector('#part-ex-search');

        // valuation steps
        this.valuationStepsBlock = this.el.querySelector('#part-ex-search-valuation-steps');
        this.searchFormBlock = this.el.querySelector('#part-ex-search-car-details-form');
        this.searchInputRegistrationNumber = this.searchFormBlock.querySelector('#search-input-registration-number');
        this.searchInputMileage = this.searchFormBlock.querySelector('#search-input-mileage');
        this.carValuationCancel = this.searchFormBlock.querySelector('#car-valuation-cancel');

        // steps blocks
        this.carFoundHeader = this.el.querySelector('#part-ex-search-car-found');
        this.outstandingFinanceInput = this.el.querySelector('#part-ex-search-os-finance-input');

        this.searchFinanceBlock = this.el.querySelector('#part-ex-search-finance-form');

        this.outstandingFinanceYes = this.searchFinanceBlock.querySelector('#part-ex-search-outstanding-yes');
        this.outstandingFinanceNo = this.searchFinanceBlock.querySelector('#part-ex-search-outstanding-no');
        this.searchFinanceSubmitButton = this.searchFinanceBlock.querySelector('.form_submit_wrapper');

        this.outstandingFinanceAmount = this.searchFinanceBlock.querySelector('#outstanding-finance-amount');
        this.outstandingFinanceMileage = this.searchFinanceBlock.querySelector('#outstanding-finance-mileage');
        this.outstandingFinanceSpecs = this.searchFinanceBlock.querySelector('#outstanding-finance-specs');
        this.outstandingFinanceCorrelationId = this.searchFinanceBlock.querySelector('#outstanding-finance-correlation-id');

        this.valuationSummaryBlock = this.el.querySelector('#part-ex-search-valuation-summary');

        this.searchValuationBlock = this.el.querySelector('#part-ex-search-valuation');
        this.searchValuationHeader = this.searchValuationBlock.querySelector('#part-ex-search-valuation-header');

        this.carFoundOptions = this.el.querySelector('#part-ex-search-car-found-options');

        this.searchValuationEstimateBlockLeft = this.el.querySelector('#part-ex-search-estimate-block-left');
        this.searchValuationEstimateBlockRight = this.el.querySelector('#part-ex-search-estimate-block-right');

        // specs table
        this.searchVehicleDetails = this.el.querySelector('#part-ex-search-vehicle-details');

        this.configuratorNav = this.parent.parent.el.querySelector('.configurator--nav');

        this.modelCode = this.data.model.modelBodyCode;
    }

    getInitialDisplayState() {
        const elements = [
            this.noMoreValuationsSearch,
            this.carSearchFailed,
            this.carValuationFailed,
            this.searchBlock,
            this.valuationStepsBlock,
            this.searchFormBlock,
            this.searchInputRegistrationNumber,
            this.searchInputMileage,
            this.carFoundHeader,
            this.outstandingFinanceInput,
            this.searchFinanceBlock,
            this.outstandingFinanceYes,
            this.outstandingFinanceNo,
            this.searchFinanceSubmitButton,
            this.outstandingFinanceAmount,
            this.outstandingFinanceMileage,
            this.outstandingFinanceSpecs,
            this.outstandingFinanceCorrelationId,
            this.valuationSummaryBlock,
            this.searchValuationBlock,
            this.searchValuationHeader,
            this.carFoundOptions,
            this.searchValuationEstimateBlockLeft,
            this.searchValuationEstimateBlockRight,
            this.searchVehicleDetails,
        ];

        if (elements && elements.length) {
            elements.forEach((ele, i) => {
                if (getComputedStyle(ele).display === 'none') {
                    this.displayState.hidden.push(ele);
                } else {
                    this.displayState.visible.push(ele);
                }
            });
        }
    }

    setTemplates() {
        // templates
        this.templates = {
            carOptions: _.template(this.el.querySelector('#part-ex-search-car-found-options-template').innerHTML.replaceAll('\\', '')),
            carSpecs: _.template(this.el.querySelector('#part-ex-search-vehicle-details-template').innerHTML.replaceAll('\\', '')),
            valuationEstimatesLeft: _.template(this.el.querySelector('#part-ex-search-estimate-block-left-template').innerHTML.replaceAll('\\', '')),
            valuationEstimatesRight: _.template(this.el.querySelector('#part-ex-search-estimate-block-right-template').innerHTML.replaceAll('\\', '')),
        };
    }

    initForms() {
        // forms
        this.searchForm = new Form(this.el.querySelector('#part-ex-search-car-details-form'), {
            onSubmit: () => this.onSearchSubmit(),
            onSuccess: (result) => this.onSearchSuccess(result),
            onError: (result) => this.onSearchError(result),
        });

        this.searchFinanceForm = new Form(this.el.querySelector('#part-ex-search-finance-form'), {
            onSubmit: () => this.onSearchFinanceSubmit(),
            onSuccess: (result) => this.onSearchFinanceSuccess(result),
            onError: (result) => this.onSearchFinanceError(result),
        });
    }

    bind() {
        this.carValuationCancel.addEventListener('click', (e) => {
            this.parent.onNoPartEx(e)
            this.parent.el.scrollIntoView({ behavior: "smooth", block: "center", });
        });
        this.carFoundOptions.addEventListener('click', (e) => this.onCarSelect(e));
        this.carFoundOptions.addEventListener('keydown', (e) => this.onCarSelectKeydown(e));
        this.outstandingFinanceYes.addEventListener('click', (e) => this.showOutstandingFinance(e, true));
        this.outstandingFinanceNo.addEventListener('click', (e) => this.showOutstandingFinance(e, false));
        this.searchInputRegistrationNumber.addEventListener('input', (e) => this.toUppercase(e));

        this.searchValuationEstimateBlockLeft.addEventListener('click', (e) => this.onEditAmount(e));
        this.searchValuationEstimateBlockRight.addEventListener('click', (e) => this.onEditAmount(e));
    }

    toUppercase(e) {
        const element = e.target;
        const selection = element.selectionStart;

        element.value = element.value.toUpperCase();
        element.setSelectionRange(selection, selection);
    }

    onEditAmount(e) {
        const el = e.target.closest('#part-ex-search-edit-amount');

        if (el) {
            e.preventDefault();

            this.parent.showElements([this.valuationStepsBlock]);
            this.parent.hideElements([this.searchValuationBlock, this.searchValuationEstimateBlockLeft, this.searchValuationEstimateBlockRight]);
        }
    }

    onCarSelect(e) {
        e.preventDefault();
        const allOptions = this.carFoundOptions.querySelectorAll('.btn--default');
        const el = e.target.closest('.btn--default');

        if (el) {
            this.partEx.carSelected = el.dataset.id;
            this.parent.removeActive(allOptions);
            this.parent.setActive([el]);
            this.updateCarFoundOptionsA11y();
            this.parent.showElements([this.searchFinanceBlock]);

            this.renderSearchVehicleDetails();

            let modelCode = this.modelCode;
            let buttonText = el.textContent?.trim() || '';

            this.selectedCarText = buttonText;

            AnalyticsHelper.push({
                'event': 'configurator_part_exchange_car_select',
                'eventCategory': 'Car Configurator',
                'eventAction': 'car selected',
                'eventLabel': `cars|${modelCode}|configurator|Step 5. Part Exchange|${buttonText}|internal|middle|#`,
                'actionType': 'car selected',
                'businessUnit': 'cars',
                'moduleName':'configurator',
                'clickText': `${buttonText}`,
                'clickType': 'internal',
                'destinationURL': '#',
                'configuratorStepName':'Step 5. Part Exchange',
                'modelSelected': `${modelCode}`,
                'inPageLocation': 'middle'
            });
        }
    }

    onCarSelectKeydown(e) {
        const key = e.key;
        if (key !== KEYS.ARROW_LEFT
            && key !== KEYS.ARROW_RIGHT
            && key !== KEYS.ARROW_UP
            && key !== KEYS.ARROW_DOWN
            && key !== KEYS.HOME
            && key !== KEYS.END
            && key !== KEYS.SPACE
            && key !== KEYS.ENTER) {
            return;
        }

        const options = [...this.carFoundOptions.querySelectorAll('.btn--default[role="radio"]')];
        if (!options.length) {
            return;
        }

        const focused = e.target.closest('.btn--default[role="radio"]');
        const focusedIndex = Math.max(0, options.indexOf(focused));

        if (key === KEYS.SPACE || key === KEYS.ENTER) {
            if (focused) {
                e.preventDefault();
                focused.click();
            }
            return;
        }

        e.preventDefault();

        let nextIndex = focusedIndex;
        if (key === KEYS.HOME) {
            nextIndex = 0;
        } else if (key === KEYS.END) {
            nextIndex = options.length - 1;
        } else if (key === KEYS.ARROW_LEFT || key === KEYS.ARROW_UP) {
            nextIndex = (focusedIndex - 1 + options.length) % options.length;
        } else if (key === KEYS.ARROW_RIGHT || key === KEYS.ARROW_DOWN) {
            nextIndex = (focusedIndex + 1) % options.length;
        }

        options[nextIndex]?.focus();
    }

    updateCarFoundOptionsA11y() {
        const options = [...this.carFoundOptions.querySelectorAll('.btn--default[role="radio"]')];
        if (!options.length) {
            return;
        }

        const active = options.find((o) => o.classList.contains('active')) || options[0];
        options.forEach((o) => {
            const isActive = o === active;
            o.setAttribute('aria-checked', isActive ? 'true' : 'false');
            o.setAttribute('tabindex', isActive ? '0' : '-1');
        });
    }

    showOutstandingFinance(e, flag) {
        e.preventDefault();
        this.partEx.hasOutstandingFinance = false;

        this.updateFinanceAnalytics(flag);

        if (flag) {
            this.parent.showElements([
                this.outstandingFinanceInput,
                this.searchFinanceSubmitButton,
            ]);
            this.parent.setActive([this.outstandingFinanceYes]);
            this.parent.removeActive([this.outstandingFinanceNo]);
            this.partEx.hasOutstandingFinance = true;
        } else {
            this.parent.showElements([this.searchFinanceSubmitButton]);
            this.parent.hideElements([this.outstandingFinanceInput]);
            this.parent.removeActive([this.outstandingFinanceYes]);
            this.parent.setActive([this.outstandingFinanceNo]);
            this.partEx.hasOutstandingFinance = false;
        }
    }

    updateFinanceAnalytics(flag) {
        let eventName = '';
        let clickText = '';

        if (flag) {
            eventName = 'configurator_part_exchange_finance_yes';
            clickText = this.outstandingFinanceYes?.textContent + '|' + this.selectedCarText;
        } else {
            eventName = 'configurator_part_exchange_finance_no';
            clickText = this.outstandingFinanceNo?.textContent + '|' + this.selectedCarText;
        }

        AnalyticsHelper.push({
            'event': `${eventName}`,
            'eventCategory': 'Car Configurator',
            'eventAction': 'finance outstanding',
            'eventLabel': `cars|${this.modelCode}|configurator|Step 5. Part Exchange|${clickText}|internal|middle|#`,
            'actionType': 'finance outstanding',
            'businessUnit' : 'cars',
            'moduleName': 'configurator',
            'clickText': `${clickText}`,
            'clickType': 'internal',
            'destinationURL': '#',
            'configuratorStepName': 'Step 5. Part Exchange',
            'modelSelected': `${this.modelCode}`,
            'inPageLocation': 'middle'
        });
    }

    renderSearchVehicleDetails() {
        const { carSelected, searchedCarSpecs } = this.partEx;

        const carSpecs = searchedCarSpecs.filter((car) => car.identifier === carSelected)[0];
        const { mileage } = this.partEx;

        const specsTable = this.searchVehicleDetails.querySelector('.configurator--table');
        specsTable.innerHTML = this.templates.carSpecs({
            carSpecs,
            mileage,
            dateFormat,
            formatPrice: this.formatPrice,
            numberFormat: getNumberFormat,
        });

        this.partEx.selectedCarSpecs = carSpecs;
        this.parent.showElements([this.searchVehicleDetails]);
        this.parent.removeActive([this.outstandingFinanceYes, this.outstandingFinanceNo]);

        let scrollOffset = this.configuratorNav.clientHeight + 20;
        scrollToElement(this.searchVehicleDetails, -scrollOffset);

        this.outstandingFinanceMileage.value = this.partEx.mileage;
        this.outstandingFinanceSpecs.value = JSON.stringify(this.partEx.selectedCarSpecs);
        this.outstandingFinanceCorrelationId.value = this.partEx.correlationId;
        Tooltip.init();
    }

    renderSelectedCarOption() {
        this.valuationSelectedCar.innerHTML = this.templates.valuationSelectedCar({
            carSpecs: this.partEx.selectedCarSpecs,
            formatPrice: this.formatPrice,
        });

        this.valuationSelectedCarMobile.innerHTML = this.templates.valuationSelectedCar({
            carSpecs: this.partEx.selectedCarSpecs,
            formatPrice: this.formatPrice,
        });
    }

    onSearchSubmit() {
        this.parent.showLoader();
        this.partEx.registrationNumber = this.searchInputRegistrationNumber.value;
        this.partEx.mileage = this.searchInputMileage.value;
    }

    // car search from registration number
    onSearchSuccess(result) {
        this.parent.hideElements([this.searchFormBlock]);
        this.renderCarOptions(result);
        this.partEx.searchedCarSpecs = result?.data?.vehicleSpecifications;
        this.partEx.correlationId = result?.data?.correlationId;
        this.parent.hideLoader();

        let modelCode = this.modelCode;
        let buttonText = this.searchFormBlock.querySelector('button[type="submit"]')?.textContent?.trim() || '';

        AnalyticsHelper.push({
            'event': 'configurator_part_exchange_valuation',
            'eventCategory': 'Car Configurator',
            'eventAction': 'value my vehicle',
            'eventLabel': `cars|${modelCode}|configurator|Step 5. Part Exchange|${buttonText}|internal|middle|#`,
            'actionType': 'value my vehicle',
            'businessUnit' : 'cars',
            'moduleName': 'configurator',
            'clickText': `${buttonText}`,
            'clickType': 'internal',
            'destinationURL': '#',
            'configuratorStepName': 'Step 5. Part Exchange',
            'modelSelected': `${modelCode}`,
            'inPageLocation': 'middle'
        });
    }

    onSearchError(result) {
        this.searchForm.showError();
        this.parent.showElements([this.carSearchFailed]);
        this.parent.hideLoader();
    }

    onSearchFinanceSubmit() {
        this.parent.loader.querySelector('.loader').classList.add('bottom');

        this.parent.showLoader();
        this.partEx.outstandingFinanceAmount = this.partEx.hasOutstandingFinance ? Number(this.outstandingFinanceAmount.value) : 0;
    }

    onSearchFinanceSuccess(result) {
        this.parent.hideElements([this.valuationStepsBlock]);
        this.parent.showElements([this.searchValuationBlock, this.searchValuationEstimateBlockLeft, this.searchValuationEstimateBlockRight]);

        this.partEx.searchedValuationResponse = result?.data;
        this.partEx.id = result?.data?.id;
        this.partEx.searchedValuationAmount = result?.data?.valuation?.current?.valuation;

        const {
            make, model, colour, registrationNumber,
        } = result?.data?.providedData?.vehicleSpecifications;
        this.partEx.searchedValuationVehicle = [make, model, colour].join(' ');
        this.partEx.searchedCarRegistrationNumber = registrationNumber;
        this.partEx.equity = (Number(this.partEx.searchedValuationAmount) - Number(this.partEx.outstandingFinanceAmount)).toFixed(2);

        this.renderValuationEstimate();

        let scrollOffset = this.configuratorNav.clientHeight + 20;
        scrollToElement(this.searchValuationBlock, -scrollOffset);

        this.parent.updateValuationResult({ view: 'search' });
        this.myAccount2.client.flushCache('car-valuations');
        this.parent.hideLoader();

        // remove styles
        this.parent.loader.querySelector('.loader').classList.remove('bottom');

        const clickText = this.searchFinanceBlock.querySelector('button[type="submit"]')?.textContent + '|' + this.selectedCarText;

        AnalyticsHelper.push({
            'event': 'configurator_part_exchange_finance_value',
            'eventCategory': 'Car Configurator',
            'eventAction': 'finance outstanding',
            'eventLabel': `cars|${this.modelCode}|configurator|Step 5. Part Exchange|${clickText}|internal|middle|#`,
            'actionType': 'finance outstanding',
            'businessUnit' : 'cars',
            'moduleName': 'configurator',
            'clickText': `${clickText}`,
            'clickType': 'internal',
            'destinationURL': '#',
            'configuratorStepName': 'Step 5. Part Exchange',
            'modelSelected': `${this.modelCode}`,
            'inPageLocation': 'middle'
        });

        pushEmailAnalytics({formName:"exchange_form_submit", model:this.modelCode});
    }

    onSearchFinanceError() {
        this.searchFinanceForm.showError();
        this.parent.showElements([this.carValuationFailed]);
        this.parent.hideLoader();
    }

    renderCarOptions(result) {
        const carOptions = result?.data?.vehicleSpecifications;
        this.carFoundOptions.innerHTML = this.templates.carOptions({
            carOptions,
            formatPrice: this.formatPrice,
        });

        this.updateCarFoundOptionsA11y();

        this.parent.showElements([
            this.valuationStepsBlock,
            this.carFoundOptions,
            this.carFoundHeader,
        ]);
    }

    renderValuationEstimate() {
        this.searchValuationEstimateBlockLeft.innerHTML = this.templates.valuationEstimatesLeft({
            partEx: this.partEx,
            formatPrice: this.formatPrice,
        });

        this.searchValuationEstimateBlockRight.innerHTML = this.templates.valuationEstimatesRight({
            partEx: this.partEx,
            formatPrice: this.formatPrice,
        });

        Tooltip.init();
    }

    async showSearchView() {
        this.parent.showLoader();
        await this.partEx.getCarSavedValuations();
        this.parent.hideLoader();

        this.resetView();

        this.parent.setActive([this.parent.searchButton]);
        this.parent.removeActive([this.parent.noPartExButton, this.parent.savedButton]);

        if (this.partEx?.savedValuations?.data && this.partEx?.savedValuations?.data.length >= 3) {
            this.parent.hideElements([this.searchFormBlock, this.searchBlock]);
            this.parent.showElements([this.noMoreValuationsSearch]);
        } else {
            this.parent.hideElements([this.noMoreValuationsSearch]);
            this.parent.showElements([this.searchFormBlock, this.searchBlock]);
        }
    }

    hideSearchView() {
        this.parent.hideElements([this.searchBlock, this.noMoreValuationsSearch, this.searchFormBlock, this.searchValuationBlock]);
    }

    resetView() {
        this.parent.hideElements(this.displayState.hidden);
        this.parent.showElements(this.displayState.visible);
    }
}
